exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "html, body, body #app, body #app>div{\n    height: 100%;\n}", ""]);

// exports
